import React from 'react'
import axios from 'axios';
import utils from '../../Utils';
import { Button } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Link } from 'react-router-dom'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';



import style from 'style/quiz.css'

class Question extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      userAnswer: '-1'
    }
  }
  componentDidMount() {

  }
  fullName = (patient) => {
    return patient.fname + ((patient.lname && patient.fname) && ' ') + patient.lname
  }
  handleChange = (event) => {
    // console.log(event.target.value, 'user select a radio')
    this.setState({ userAnswer: event.target.value })
    this.props.setAnswer(this.props.index, event.target.value)
  }
  render() {
    return (
      <div class="quiz-item card">
        <div class='quiz-question'>
          {this.props.question.q}
        </div>
        {this.props.question.desc && <div class='quiz-desc'>{this.props.question.desc}</div>}
        <div class='quiz-answers'>
          {
            this.props.question.a.map((answer, index) => {
              return <div key={index}>
                <Radio
                  checked={this.state.userAnswer === `${index}`}
                  onChange={this.handleChange}
                  value={`${index}`}
                  name={`form${this.props.index}`}
                />
                <span> {answer}</span>
              </div>
            })
          }
          {/* <FormControl component="fieldset" >
            <RadioGroup name={this.props.index + 'ch'} value={this.state.userAnswer} onChange={this.handleChange}>
              {
                this.props.question.a.map((answer, index) => {
                  return <FormControlLabel value={index} control={<Radio />} label={answer} key={index} />
                })
              }
            </RadioGroup>
          </FormControl> */}
        </div>

      </div >
    )
  }
}
export default Question;